import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'

import { noop } from 'lodash'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconButton, Menu, MenuItem, SvgIcon } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'
import { ONE_TIME_TRIGGER } from 'components/SegmentSelector/outreach-message-trigger-constants'
import useIsShadow from 'common/use-is-shadow'
import { useOpenModalForCopy, useOpenModalForEdit } from 'components/ComposeOutreachMessageButton/Context'
import {
  faEdit,
  faSkullCrossbones,
  faTrash,
  faEllipsisV,
  faMinusCircle,
  faPlusCircle,
  faCopy,
} from '@fortawesome/pro-solid-svg-icons'

const targetOrigin = { vertical: 'top', horizontal: 'right' }

const Icon = styled(FontAwesomeIcon)({
  marginRight: 6,
})

const Actions = ({ record, onDelete, onEnable, onDisable }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const isShadow = useIsShadow()
  const openEditModal = useOpenModalForEdit()
  const openCopyModal = useOpenModalForCopy()

  const id = `${record.Id}-action-menu`

  const onEdit = () => openEditModal(record)
  const onCopy = () => openCopyModal(record)
  const handleClick = (event) => setAnchorEl(event.currentTarget)
  const handleCloseWrapper =
    (fn = noop) =>
    () => {
      setAnchorEl(null)
      fn()
    }

  const canEdit = record.IsDraft || record.Trigger !== ONE_TIME_TRIGGER || record.Status === 'Scheduled'
  const canAdminEdit = !canEdit && record.Trigger === ONE_TIME_TRIGGER && isShadow
  const canEnable = record.Trigger !== ONE_TIME_TRIGGER && record.Disabled === true
  const canDisable = record.Trigger !== ONE_TIME_TRIGGER && (record.Disabled === undefined || record.Disabled === false)
  return (
    <Fragment>
      <IconButton
        aria-label="open actions menu"
        aria-controls={id}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <SvgIcon fontSize="small">
          <FontAwesomeIcon icon={faEllipsisV} />
        </SvgIcon>
      </IconButton>
      <Menu
        id={id}
        variant="menu"
        anchorEl={anchorEl}
        anchorOrigin={targetOrigin}
        transformOrigin={targetOrigin}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseWrapper()}
      >
        {canEdit && (
          <MenuItem onClick={handleCloseWrapper(onEdit)}>
            <Icon icon={faEdit} />
            Edit
          </MenuItem>
        )}
        {canAdminEdit && (
          <MenuItem onClick={handleCloseWrapper(onEdit)}>
            <Icon icon={faSkullCrossbones} />
            Admin Edit
          </MenuItem>
        )}
        {canEnable && (
          <MenuItem onClick={handleCloseWrapper(onEnable)}>
            <Icon icon={faPlusCircle} />
            Enable
          </MenuItem>
        )}
        {canDisable && (
          <MenuItem onClick={handleCloseWrapper(onDisable)}>
            <Icon icon={faMinusCircle} />
            Disable
          </MenuItem>
        )}
        <MenuItem onClick={handleCloseWrapper(onDelete)}>
          <Icon icon={faTrash} />
          Delete
        </MenuItem>
        <MenuItem onClick={handleCloseWrapper(onCopy)}>
          <Icon icon={faCopy} />
          Copy
        </MenuItem>
      </Menu>
    </Fragment>
  )
}
Actions.propTypes = {
  record: PropTypes.shape({
    Id: PropTypes.string.isRequired,
    Trigger: PropTypes.string.isRequired,
    IsDraft: PropTypes.bool,
    Disabled: PropTypes.bool,
  }),
  onDelete: PropTypes.func.isRequired,
  onEnable: PropTypes.func.isRequired,
  onDisable: PropTypes.func.isRequired,
}

export default Actions
